import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { ProjectManagersService } from "@/modules/projects/service/projectManagers";
import { FetchListRequest } from "@/services/api";
import { DisplayProjectManager } from "@/types/projectManager";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

export const useProjectManagersQuery = ({
  projectId,
  enabled = true,
  name = "projectManagers",
}: {
  projectId: string;
  enabled?: boolean;
  name?: string;
}) => {
  const options = useCreateDataTableOptions<DisplayProjectManager>(name);
  const fetchList = (fetchParams: FetchListRequest<DisplayProjectManager>) => {
    return ProjectManagersService.getList(projectId, fetchParams);
  };

  const queryKey = useDynamicQueryParams([name, projectId], options);
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchList({
        lastItem: pageParam,
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    query,
    options,
    queryKey,
  };
};
